import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import ParkingSthlm from '../PopupTemplates/ParkingSthlm';
import { ParkingsSthlmBase } from '../Sources/ParkingsSthlm/ParkingBase';
import { affectedArea } from './AffectedArea';

function createInformationLayer(feature) {
    return affectedArea(feature.properties.wKT);
}

function parkingBase(name: string, sourceOptions: { parkingType: string }, iconId?: number) {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: name,
        itemPlural: 'parkeringar',
        source: new ParkingsSthlmBase(sourceOptions.parkingType, iconId),
        createInformationLayer: createInformationLayer,
        persistentInformationLayer: false,
        popupTemplate: ParkingSthlm,
        defaultIconId: iconId,
    };

    return function (options?: ClusteredMarkerLayerOptions) {
        return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
    };
}

export const parkingsSthlmBus = parkingBase('Parkering för buss och lastbil', { parkingType: 'pbuss' }, 204);
export const parkingsSthlmTruck = parkingBase('Parkering för buss och lastbil', { parkingType: 'plastbil' }, 202);
export const parkingsSthlmDisabled = parkingBase('Parkering för rörelsehindrade', { parkingType: 'prorelsehindrad' }, 201);
export const parkingsSthlmMC = parkingBase('Motorcykelparkering', { parkingType: 'pmotorcykel' }, 203);
